import { List, ListItemProps } from "@p0security/ui";
import classNames from "classnames";

/** Below the desktop breakpoint the row's actions stack under the request
 * instead of sitting beside it, and the dividers between them are dropped. */
const STACKED_ACTION_CLASSES =
  "[&_.ant-list-item-action]:mt-3! [&_.ant-list-item-action]:ml-0! [&_.ant-list-item-action]:flex! [&_.ant-list-item-action]:max-w-full! [&_.ant-list-item-action]:flex-col! [&_.ant-list-item-action]:items-start! [&_.ant-list-item-action]:gap-1.5! [&_.ant-list-item-action>li]:p-0! [&_.ant-list-item-action-split]:hidden!";

export const StyledRequestControls: React.FC<
  ListItemProps & { isDesktop?: boolean }
> = ({ className, isDesktop, ...props }) => (
  <List.Item
    className={classNames(className, { [STACKED_ACTION_CLASSES]: !isDesktop })}
    {...props}
  />
);
